import React        from 'react';
import Utils from './Utils';

export const UtilsConfig = {
    routes  : [
        {
            path      : '/utils',
            component : Utils,
            permission: { component_name: 'utils', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/utils/UtilsConfig.js